import { MARQUEE } from "@/lib/site";

function Row() {
  return (
    <div className="flex shrink-0 items-center gap-10 pr-10">
      {MARQUEE.map((m, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="font-serif italic text-4xl md:text-6xl text-secondary/90 whitespace-nowrap">
            {m}
          </span>
          <span className="h-2.5 w-2.5 rounded-full bg-primary shrink-0" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section className="py-10 md:py-14 border-y border-border bg-muted/40 overflow-hidden" data-testid="marquee">
      <div className="flex marquee-track w-max">
        <Row />
        <Row />
      </div>
    </section>
  );
}
